import type * as React from 'react';

import type { NavigationScreenCollectionState } from '@gitbook/app-navigation';

import { NavigationRedirect } from '../../navigation';

/**
 * Screen when viewing a collection.
 */
export function CollectionScreen(props: {
    screen: NavigationScreenCollectionState;
}): React.ReactElement {
    return (
        <NavigationRedirect
            to={{
                screen: {
                    type: 'home',
                    organization: props.screen.organization,
                },
            }}
        />
    );
}
